export default [
  {
    path: "/",
    redirect: "/profile" // default route
  },
  {
    path: "*",
    redirect: "/not-found" // 404
  }
]
